import(/* webpackMode: "eager" */ "/bigspring/packages/app/app/error.tsx");
